module.exports = __webpack_public_path__ + "static/media/COTK2_4.8879a217.png";